define(
    'NMSDesignSystem.FluReimbursement.Shopping',
    [
        'Backbone',
        'Utils',
        'nms_flu_vaccine_reimbursement.tpl'
    ],
    function NMSDesignSystemFluReimbursementShopping(
        Backbone,
        Utils,
        nmsFluVaccineReimbursementTpl
    ) {
        'use strict';

        var pageRoute = '/flu-vaccine-reimbursement';
        var cmsPricingUrl = 'https://www.cms.gov/medicare/payment/part-b-drugs/vaccine-pricing';
        var cmsProviderUrl = 'https://www.cms.gov/flu-provider';
        var rows = [
            {
                code: '90661',
                descriptor: 'CCIIV3 VAC ABX FR 0.5 ML IM',
                labeler: 'Seqirus',
                productName: 'Flucelvax Trivalent (2026/2027) Preservative Free',
                allowance: '$66.57',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '/flucelvax-trivalent-2026-2027-prefilled-syringes-10',
                itemIds: ['70461065603'],
                nameMatch: ['flucelvax', '2026']
            },
            {
                code: '90653',
                descriptor: 'IIV adjuvant vaccine IM',
                labeler: 'Seqirus',
                productName: 'Fluad Trivalent (2026/2027) Preservative Free',
                allowance: '$122.52',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '/fluad-trivalent-2026-2027-prefilled-syringes-10',
                itemIds: ['70461002603'],
                nameMatch: ['fluad', '2026']
            },
            {
                code: '90656',
                descriptor: 'IIV3 VACC NO PRSV 0.5 ML IM',
                labeler: 'Sanofi Pasteur',
                productName: 'Fluzone Trivalent PFS (2026/2027) Preservative Free',
                allowance: '$23.89',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '/fluzone-trivalent-2026-2027-prefilled-syringes-10',
                itemIds: ['49281042650'],
                nameMatch: ['fluzone', 'prefilled', '2026'],
                nameExclude: ['high-dose', 'pediatric']
            },
            {
                code: '90657',
                descriptor: 'IIV3 VACCINE SPLT 0.25 ML IM',
                labeler: 'Sanofi Pasteur',
                productName: 'Fluzone Trivalent (2026/2027) – Pediatric Dose',
                allowance: '$11.14',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '',
                itemIds: [],
                nameMatch: ['fluzone', 'pediatric', '2026']
            },
            {
                code: '90658',
                descriptor: 'IIV3 VACCINE SPLT 0.5 ML IM',
                labeler: 'Sanofi Pasteur',
                productName: 'Fluzone Trivalent MDV (2026/2027)',
                allowance: '$22.28',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '/FLUZONE-TIV-10-DOSE-VIAL-2026',
                itemIds: ['49281064515'],
                nameMatch: ['fluzone', 'multi-dose', '2026']
            },
            {
                code: '90662',
                descriptor: 'IIV NO PRSV increased AG IM',
                labeler: 'Sanofi Pasteur',
                productName: 'Fluzone High-Dose Trivalent (2026/2027) Preservative Free',
                allowance: '$122.52',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '/fluzone-high-dose-trivalent-2026-2027-prefilled-syringes-10',
                itemIds: ['49281012665'],
                nameMatch: ['fluzone', 'high-dose', '2026']
            },
            {
                code: '90673',
                descriptor: 'RIV3 Vaccine no preserv IM',
                labeler: 'Sanofi Pasteur',
                productName: 'Flublok Trivalent Preservative Free (2026/2027)',
                allowance: '$122.52',
                effectiveDates: '08/01/2026–07/31/2027',
                productUrl: '/flublok-trivalent-2026-2027-prefilled-syringes-10',
                itemIds: ['49281072610'],
                nameMatch: ['flublok', '2026']
            }
        ];

        function readValue(source, key) {
            if (!source) {
                return '';
            }

            return source.get ? source.get(key) : source[key];
        }

        function normalize(value) {
            return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
        }

        function normalizeItemId(value) {
            return String(value || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
        }

        function isBuyFluShotsSite() {
            var hostname = typeof window !== 'undefined' && window.location
                ? String(window.location.hostname || '').toLowerCase()
                : '';

            return hostname === 'buyflushots.nmsincusa.com' ||
                hostname === 'buyflu-sandbox.ethanablatt.com';
        }

        function rowForItem(item) {
            var itemId = normalizeItemId(
                readValue(item, 'itemid') ||
                readValue(item, '_sku') ||
                readValue(item, 'sku')
            );
            var name = normalize(
                readValue(item, 'storedisplayname2') ||
                readValue(item, 'displayname') ||
                readValue(item, '_name')
            );

            var exact = rows.filter(function matchesExactItem(row) {
                return itemId && row.itemIds.some(function matchesItemId(candidate) {
                    return normalizeItemId(candidate) === itemId;
                });
            })[0];

            if (exact) {
                return exact;
            }

            return rows.filter(function matchesProductName(row) {
                var includesRequiredParts = row.nameMatch.every(function includesNamePart(part) {
                    return name.indexOf(normalize(part)) !== -1;
                });
                var includesExcludedPart = (row.nameExclude || []).some(function includesExcludedNamePart(part) {
                    return name.indexOf(normalize(part)) !== -1;
                });

                return name && includesRequiredParts && !includesExcludedPart;
            })[0] || null;
        }

        var ReimbursementView = Backbone.View.extend({
            template: nmsFluVaccineReimbursementTpl,

            getTitle: function getTitle() {
                return Utils.translate('2026–2027 Flu Vaccine Reimbursement');
            },

            getBreadcrumbPages: function getBreadcrumbPages() {
                return [{
                    text: Utils.translate('Flu Vaccine Reimbursement'),
                    href: pageRoute
                }];
            },

            getContext: function getContext() {
                return {
                    rows: rows,
                    comparisonRows: [rows[0], rows[2]],
                    cmsPricingUrl: cmsPricingUrl,
                    cmsProviderUrl: cmsProviderUrl
                };
            }
        });

        function registerPage(container) {
            if (!isBuyFluShotsSite()) {
                return;
            }

            var pageType = container && container.getComponent
                ? container.getComponent('PageType')
                : null;

            if (!pageType || pageType.nmsFluReimbursementRegistered) {
                return;
            }

            pageType.registerPageType({
                name: 'NMSFluVaccineReimbursement',
                routes: ['flu-vaccine-reimbursement'],
                view: ReimbursementView,
                defaultTemplate: {
                    name: 'nms_flu_vaccine_reimbursement.tpl',
                    displayName: 'Flu vaccine reimbursement',
                    thumbnail: Utils.getThemeAbsoluteUrlOfNonManagedResources(
                        'img/default-layout-cms-landing-page.png'
                    )
                }
            });
            pageType.nmsFluReimbursementRegistered = true;
        }

        return {
            mountToApp: registerPage,
            getForItem: rowForItem,
            pageRoute: pageRoute
        };
    }
);
